import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DeviceList from '../components/device/DeviceList';
import DeviceDetail from '../components/device/DeviceDetail';

interface DevicePageProps {
  isSocketConnected?: boolean;
}

const DevicePage: React.FC<DevicePageProps> = ({ isSocketConnected = false }) => {
  return (
    <Routes>
      <Route 
        path="/" 
        element={<DeviceList />} 
      />
      <Route 
        path="/:deviceId" 
        element={<DeviceDetail isSocketConnected={isSocketConnected} />} 
      />
    </Routes>
  );
};

export default DevicePage;
